<template>
    <div
        class="container container--slim step-thx-page step--upload-result--succeeded"
    >
        <h1 class="container__client-zone-header">
            {{ t(`${TRANSLATION_KEY}.header`) }}
        </h1>

        <div class="image-wrapper">
            <img class="w-80" :src="okIcon" alt="Success" />
        </div>
        <div>
            <p class="container__subheader t-center t-bold">
                {{ t(`${TRANSLATION_KEY}.subheader`) }}
            </p>
        </div>
        <button
            type="button"
            class="button button--submit"
            @click="handleRedirect"
        >
            {{ $t(`${TRANSLATION_KEY}.logInToYourAccount`) }}
        </button>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { SET_STEP } from '@/constants/mutation-types';
import store from '@/store';
import okIcon from '@/assets/ok2.svg';

const TRANSLATION_KEY = 'steps.esgSubmit';

// i18n
const { t } = useI18n();

const handleRedirect = () => {
    store.state.navigationService.goToRoute('newLogin');
};

onMounted(() => {
    store.commit(SET_STEP, 'esgSubmit');
});
</script>
